import { classNames } from "@NBCUDTC/reactjs-utility-belt/classnames";

import { Image } from "@/components/atoms/Image";
import { TileFormat } from "@/utils/GetTileFormat/types";
import number1 from "@/assets/img/peacock/top10/1.png";
import number2 from "@/assets/img/peacock/top10/2.png";
import number3 from "@/assets/img/peacock/top10/3.png";
import number4 from "@/assets/img/peacock/top10/4.png";
import number5 from "@/assets/img/peacock/top10/5.png";
import number6 from "@/assets/img/peacock/top10/6.png";
import number7 from "@/assets/img/peacock/top10/7.png";
import number8 from "@/assets/img/peacock/top10/8.png";
import number9 from "@/assets/img/peacock/top10/9.png";
import number10 from "@/assets/img/peacock/top10/10.png";
import { useClassNames } from "@/utils/classNames";

import styles from "./Top10Tile.module.scss";
import { Top10TileProps } from "./types";
import { Tile34 } from "../Tile34";

const numberImages = {
  1: number1,
  2: number2,
  3: number3,
  4: number4,
  5: number5,
  6: number6,
  7: number7,
  8: number8,
  9: number9,
  10: number10,
} as const;

/**
 * Top10Tile component renders a Top10Tile for the Top 10 TV Shows/Movies Today rail.
 *
 * @param asset - The asset data to be displayed in the tile
 * @param index - The number tile in top10 this asset is
 * @param className - Additional CSS class for styling
 *
 * @returns the rendered Top10Tile component
 *
 * @example
 * ```tsx
 * <Top10Tile asset={someAsset} index={1} />
 * ```
 */
const Top10Tile = ({ asset, index, className }: Top10TileProps) => {
  const cn = useClassNames(styles, styles["top-10-tile"], className);

  const numberImage = numberImages[index as keyof typeof numberImages];

  return (
    <div className={cn}>
      <Image src={numberImage} className={styles["number"]} />
      <Tile34
        className={styles["tile"]}
        asset={asset}
        format={TileFormat.VOD}
      />
    </div>
  );
};

export { Top10Tile };
